/**
 * @generated SignedSource<<0e612a32557690f0edb68c5062e32277>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetTodoSummaryInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds?: ReadonlyArray<string> | null;
  title?: string | null;
  todoCategoryId: string;
};
export type WATodoSummaryMutation$variables = {
  input: CreateWidgetTodoSummaryInput;
  storecastId: string;
};
export type WATodoSummaryMutation$data = {
  readonly dashboard: {
    readonly createWidgetTodoSummary: {
      readonly id: string;
    };
  };
};
export type WATodoSummaryMutation = {
  response: WATodoSummaryMutation$data;
  variables: WATodoSummaryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTodoSummary",
        "kind": "LinkedField",
        "name": "createWidgetTodoSummary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATodoSummaryMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WATodoSummaryMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e72549443990c213d0246a0ca1894cda",
    "id": null,
    "metadata": {},
    "name": "WATodoSummaryMutation",
    "operationKind": "mutation",
    "text": "mutation WATodoSummaryMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTodoSummaryInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTodoSummary(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36f77317e05dd2f5e8cdc078b8c83b04";

export default node;
